var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoNaranjo2023(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 141.7 56.7",
    style: {
      enableBackground: "new 0 0 141.7 56.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#DC582A;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.8,22.8c1.6-1.6,4.1-1.7,5.9-0.4c0.3,0.2,0.7,0.2,1-0.1l1.8-1.7c0.3-0.3,0.3-0.8-0.1-1.1 C14.1,16.7,9.1,16.9,6,20C5,21,4.3,22.3,3.9,23.7c-0.1,0.5,0.2,0.9,0.7,0.9h2.6c0.3,0,0.6-0.2,0.7-0.5C8.1,23.6,8.4,23.2,8.8,22.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.8,29.1c-0.4-0.4-0.7-0.8-0.9-1.2c-0.1-0.2-0.4-0.4-0.6-0.4H4.6c-0.5,0-0.8,0.4-0.7,0.9 C4.3,29.7,5,30.9,6,31.9c1.6,1.6,3.8,2.5,6,2.5c1.9,0,3.9-0.7,5.4-2c0.3-0.3,0.3-0.7,0-1l-1.8-1.8c-0.2-0.2-0.6-0.3-0.9,0 C13,30.8,10.4,30.7,8.8,29.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.6,34h2.8c0.3,0,0.6-0.3,0.6-0.6v-8.2c0-0.3-0.3-0.6-0.6-0.6h-2.8c-0.3,0-0.6,0.3-0.6,0.6v8.2 C45,33.7,45.3,34,45.6,34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.1,21.7h13.6c0.3,0,0.5-0.2,0.5-0.5v-2.6c0-0.3-0.2-0.5-0.5-0.5H40.1c-0.3,0-0.5,0.2-0.5,0.5v2.6 C39.7,21.5,39.9,21.7,40.1,21.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.5,34h-3.2c-0.2,0-0.4-0.2-0.4-0.4v-6.8c0-0.3,0.3-0.5,0.6-0.3l3.2,1.9c0.1,0.1,0.2,0.2,0.2,0.3v4.9 C24.9,33.8,24.7,34,24.5,34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.6,22.8l-7-4.3c-0.3-0.2-0.7,0-0.7,0.4v3.4c0,0.2,0.1,0.3,0.2,0.4l7.5,4.5c0.2,0.1,0.3,0.1,0.5,0l3-1.8 c0.3-0.2,0.7,0,0.7,0.4v7.6c0,0.3,0.2,0.5,0.5,0.5h3c0.3,0,0.5-0.2,0.5-0.5V22.7v-3.4V19c0-0.4-0.4-0.6-0.7-0.4l-7,4.3 C28.9,22.9,28.7,22.9,28.6,22.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.1,8.1l-1.6,1c-0.5-0.8-1.3-1.3-2.4-1.3c-1.7,0-2.9,1.2-2.9,3c0,1.8,1.3,3,2.9,3c1,0,1.8-0.5,2.4-1.2 l1.5,1.1c-0.8,1.2-2.2,1.9-3.9,1.9c-2.8,0-4.8-2-4.8-4.7c0-2.7,2-4.7,4.8-4.7C74.9,6,76.4,6.8,77.1,8.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.4,12.1c0,0.2,0,0.4,0,0.6h-4.5c0.2,0.9,0.8,1.3,1.6,1.3c0.5,0,1.1-0.2,1.6-0.6l1,1.1c-0.7,0.7-1.6,1-2.7,1 c-1.9,0-3.3-1.3-3.3-3.3c0-2,1.3-3.3,3.2-3.3C83.2,8.8,84.4,10.2,84.4,12.1 M79.9,11.6h2.8c-0.2-0.8-0.6-1.3-1.4-1.3 C80.5,10.3,80.1,10.8,79.9,11.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.8,11.3v4h-1.7v-3.5c0-0.9-0.5-1.4-1.2-1.4c-0.7,0-1.3,0.5-1.3,1.4v3.4h-1.7V9h1.7v0.7 c0.5-0.7,1.1-0.9,1.9-0.9C90.8,8.8,91.8,9.8,91.8,11.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M98.1,10.5h-2.3v2.3c0,0.8,0.4,1.1,0.9,1.1c0.4,0,0.8-0.2,1.2-0.4l0.6,1.3c-0.6,0.4-1.2,0.7-2.1,0.7 c-1.6,0-2.4-0.9-2.4-2.5v-2.4h-1.2V9h1.2V7.1h1.7V9h2.3V10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104,9l-0.3,1.7c-0.3-0.1-0.7-0.2-1-0.2c-0.8,0-1.3,0.5-1.3,1.4v3.4h-1.7V9h1.7v0.7c0.4-0.6,1-0.9,1.8-0.9 C103.4,8.8,103.7,8.9,104,9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M111.6,12.2c0,1.9-1.5,3.3-3.4,3.3c-2,0-3.4-1.4-3.4-3.3c0-1.9,1.4-3.3,3.4-3.3 C110.1,8.8,111.6,10.3,111.6,12.2 M106.5,12.2c0,1,0.7,1.7,1.7,1.7c1,0,1.7-0.7,1.7-1.7c0-1-0.7-1.7-1.7-1.7 C107.2,10.4,106.5,11.1,106.5,12.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "78.9,32 77.1,32 77.1,25.1 74.8,31.1 72.9,31.1 70.7,25.2 70.7,32 68.8,32 68.8,22.9 71.5,22.9  73.9,29.1 76.2,22.9 78.9,22.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.7,28.8c0,0.2,0,0.4,0,0.6h-4.5c0.2,0.9,0.8,1.3,1.6,1.3c0.5,0,1.1-0.2,1.6-0.6l1,1.1c-0.7,0.7-1.6,1-2.7,1 c-1.9,0-3.3-1.3-3.3-3.3c0-2,1.3-3.3,3.2-3.3C85.5,25.5,86.7,26.9,86.7,28.8 M82.2,28.3H85c-0.2-0.8-0.6-1.3-1.4-1.3 C82.8,27,82.4,27.5,82.2,28.3 M82.5,24.8l1.3-2h2l-1.7,2H82.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92.7,26.4v-3.7h1.7V32h-1.7v-0.7c-0.4,0.5-1,0.9-1.9,0.9c-1.7,0-3.1-1.4-3.1-3.3c0-1.9,1.3-3.3,3.1-3.3 C91.6,25.5,92.3,25.9,92.7,26.4 M89.5,28.9c0,1,0.6,1.7,1.6,1.7c1,0,1.6-0.7,1.6-1.7c0-1-0.7-1.7-1.6-1.7 C90.1,27.1,89.5,27.9,89.5,28.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M98.1,23.7c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1C97.6,22.6,98.1,23,98.1,23.7  M97.9,32h-1.7v-6.3h1.7V32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.2,26.7l-1.2,1c-0.4-0.4-0.8-0.6-1.3-0.6c-0.9,0-1.6,0.7-1.6,1.7c0,1,0.7,1.7,1.6,1.7c0.5,0,1-0.2,1.4-0.6 l1.2,1c-0.6,0.8-1.5,1.2-2.5,1.2c-2,0-3.4-1.4-3.4-3.3c0-1.9,1.4-3.3,3.4-3.3C103.7,25.5,104.6,26,105.2,26.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112.8,28.9c0,1.9-1.5,3.3-3.4,3.3c-2,0-3.4-1.4-3.4-3.3c0-1.9,1.4-3.3,3.4-3.3 C111.4,25.5,112.8,27,112.8,28.9 M107.7,28.9c0,1,0.7,1.7,1.7,1.7c1,0,1.7-0.7,1.7-1.7c0-1-0.7-1.7-1.7-1.7 C108.5,27.1,107.7,27.8,107.7,28.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M122,26.4v-3.7h1.7V32H122v-0.7c-0.4,0.5-1,0.9-1.9,0.9c-1.7,0-3.1-1.4-3.1-3.3c0-1.9,1.3-3.3,3.1-3.3 C121,25.5,121.6,25.9,122,26.4 M118.8,28.9c0,1,0.6,1.7,1.6,1.7c1,0,1.6-0.7,1.6-1.7c0-1-0.7-1.7-1.6-1.7 C119.5,27.1,118.8,27.9,118.8,28.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M131.4,28.9c0,0.2,0,0.4,0,0.6h-4.5c0.2,0.9,0.8,1.3,1.6,1.3c0.5,0,1.1-0.2,1.6-0.6l1,1.1 c-0.7,0.7-1.6,1-2.7,1c-1.9,0-3.3-1.3-3.3-3.3c0-2,1.3-3.3,3.2-3.3C130.1,25.5,131.4,26.9,131.4,28.9 M126.9,28.3h2.8 c-0.2-0.8-0.6-1.3-1.4-1.3C127.5,27,127,27.5,126.9,28.3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.8,
    y: 22.7,
    className: "st0",
    width: 1.7,
    height: 9.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "75.5,41.3 72.7,41.3 72.7,48.7 70.8,48.7 70.8,41.3 68,41.3 68,39.6 75.5,39.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80.9,42.4l-0.3,1.7c-0.3-0.1-0.7-0.2-1-0.2c-0.8,0-1.3,0.5-1.3,1.4v3.4h-1.7v-6.3h1.7v0.7 c0.4-0.6,1-0.9,1.8-0.9C80.4,42.2,80.7,42.3,80.9,42.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88.3,48.7h-1.7V48c-0.4,0.5-1,0.9-1.9,0.9c-1.7,0-3.1-1.4-3.1-3.3c0-1.9,1.3-3.3,3.1-3.3 c0.9,0,1.5,0.4,1.9,0.9v-0.7h1.7V48.7z M83.4,45.6c0,1,0.6,1.7,1.6,1.7c1,0,1.6-0.7,1.6-1.7c0-1-0.7-1.7-1.6-1.7 C84.1,43.8,83.4,44.6,83.4,45.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.7,45.6c0,1.9-1.3,3.3-3.1,3.3c-0.9,0-1.5-0.3-1.9-0.9v0.7h-1.7v-9.3h1.7v3.7c0.4-0.5,1-0.8,1.9-0.8 C95.4,42.2,96.7,43.7,96.7,45.6 M91.7,45.6c0,1,0.7,1.7,1.6,1.7c1,0,1.6-0.8,1.6-1.7c0-1-0.6-1.7-1.6-1.7 C92.4,43.8,91.7,44.6,91.7,45.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.3,48.7h-1.7V48c-0.4,0.5-1,0.9-1.9,0.9c-1.7,0-3.1-1.4-3.1-3.3c0-1.9,1.3-3.3,3.1-3.3 c0.9,0,1.5,0.4,1.9,0.9v-0.7h1.7V48.7z M99.5,45.6c0,1,0.6,1.7,1.6,1.7c1,0,1.6-0.7,1.6-1.7c0-1-0.7-1.7-1.6-1.7 C100.1,43.8,99.5,44.6,99.5,45.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107.9,49.3c0,1.4-0.8,2.1-2,2.1c-0.3,0-0.7-0.1-1-0.2l0.3-1.5c0.1,0.1,0.3,0.1,0.5,0.1c0.3,0,0.5-0.2,0.5-0.7 v-6.8h1.7V49.3z M108.1,40.4c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1 C107.6,39.3,108.1,39.7,108.1,40.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115.9,48.7h-1.7V48c-0.4,0.5-1,0.9-1.9,0.9c-1.7,0-3.1-1.4-3.1-3.3c0-1.9,1.3-3.3,3.1-3.3 c0.9,0,1.5,0.4,1.9,0.9v-0.7h1.7V48.7z M111,45.6c0,1,0.6,1.7,1.6,1.7c1,0,1.6-0.7,1.6-1.7c0-1-0.7-1.7-1.6-1.7 C111.6,43.8,111,44.6,111,45.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M122.2,43.1v-3.7h1.7v9.3h-1.7V48c-0.4,0.5-1,0.9-1.9,0.9c-1.7,0-3.1-1.4-3.1-3.3c0-1.9,1.3-3.3,3.1-3.3 C121.2,42.2,121.8,42.6,122.2,43.1 M119,45.6c0,1,0.6,1.7,1.6,1.7c1,0,1.6-0.7,1.6-1.7c0-1-0.7-1.7-1.6-1.7 C119.7,43.8,119,44.6,119,45.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M132.2,45.6c0,1.9-1.5,3.3-3.4,3.3c-2,0-3.4-1.4-3.4-3.3c0-1.9,1.4-3.3,3.4-3.3 C130.7,42.2,132.2,43.7,132.2,45.6 M127.1,45.6c0,1,0.7,1.7,1.7,1.7c1,0,1.7-0.7,1.7-1.7c0-1-0.7-1.7-1.7-1.7 C127.8,43.8,127.1,44.5,127.1,45.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M137.9,42.4l-0.3,1.7c-0.3-0.1-0.7-0.2-1-0.2c-0.8,0-1.3,0.5-1.3,1.4v3.4h-1.7v-6.3h1.7v0.7 c0.4-0.6,1-0.9,1.8-0.9C137.4,42.2,137.6,42.3,137.9,42.4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.6,
    y: 5.3,
    className: "st0",
    width: 1.5,
    height: 45.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNaranjo2023);
export default __webpack_public_path__ + "static/media/LogoNaranjo2023.d0482b472af2c9daf200bd33dc5d1b08.svg";
export { ForwardRef as ReactComponent };